import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {User} from "../../auth/models/User";
import {MatPaginator} from "@angular/material/paginator";
import {Subject, takeUntil} from "rxjs";
import {AdminService} from "../services/admin.service";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";
import {CategoryDialogComponent} from "./category-dialog/category-dialog.component";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit, AfterViewInit, OnDestroy {
  categories = new MatTableDataSource<any>();
  currentUser!: User;
  displayedColumns: string[] = ['name', 'open', 'remove'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
    this.categories.paginator = this.paginator;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData() {
    if (this.currentUser) {
      this.adminService.getAllCategoriesWithTopLevel().subscribe(result => {
        if (result) {
          this.categories = new MatTableDataSource(result);
          this.categories.paginator = this.paginator;
        }
      }, (error: any) => {
        console.error(error);
      });
    }
  }

  deleteCategory(id: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted',
      'The category has been deleted.',
      'Error',
      'An error occurred while deleting the category.'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!']
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.adminService.deleteCategory(id).subscribe(() => {
            Swal.fire(translations['Deleted'], translations['The category has been deleted.'], 'success');
            this.loadData();
          }, (error) => {
            Swal.fire(translations['Error'], translations['An error occurred while deleting the category.'], 'error');
          });
        }
      });
    });
  }

  openCreateCategoryDialog(): void {
    const dialogRef = this.dialog.open(CategoryDialogComponent, {
      width: '1000px',
      height: '900px',
      data: {category: null}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  openEditCategoryDialog(category: any): void {
    const dialogRef = this.dialog.open(CategoryDialogComponent, {
      width: '1000px',
      height: '900px',
      data: {category}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }
}
